/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {

    "use strict";

    export class CollectionListCustomRowDirective implements ng.IDirective {

        public restrict         : string    = 'E';
        public scope            : Object    = {

            // Data from the enclosing collection list.
            //
            parentRecord                    : '=',
            parentRecordIndex               : '=',
            parentColumns                   : '=',

            // Can be a traditional template URL, or an embedded template like:
            //     <script type="text/ng-template" id="myCustomTemplate">
            //         <b>Nested Row Content!</b>
            //     </script>
            //
            templateIdOrUrl                 : '=',

            // Passing in the controller for the page/directive that includes the top
            // level collection list provides a generic way for a custom row in that
            // collection to provide data to the template specified in templateIdOrUrl.
            //
            // It's passed down through the collection list by specifying it in that directive
            // markup, like:
            //
            // <dealerware-collection-list
            //     name="contractSearchController.collectionListName"
            //     ...
            //     parent-controller="contractSearchController"
            // />
            //
            // That parentController needs to implement:
            //     - isActiveCustomRow (rowIndex: number) : a function that returns whether or not
            //         that customRow (attached to that row in the collection) is to be shown.
            //     - customRowTemplate : a string that becomes templateIdOrUrl (above).  @todo
            //         shortly: make this the result of a function that receives the row index so
            //         that different rows can show different templates instead of all of them
            //         having to use the same one.
            //
            collectionListParentController  : '=?'
        };
        public template                     : string    =
            '<div ng-include="rowController.templateIdOrUrl"></div>';

        public controller       : any       = ( ) => { };
        public controllerAs     : string    = 'rowController';
        public bindToController : boolean   = true;
    }

    getDealerwareWebComponentsModule()
        .directive('dealerwareCollectionListCustomRow',
            () => new CollectionListCustomRowDirective()
        );
}
